import axios from "axios";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { ClientWallet } from "@/wagmi/retx-wallet/walletClient";
import { userApi } from "@/apis";
import { dispatch } from "@/store";
import { decryptString } from "./function";
import { networkActions } from "@/store/actions";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function splitHashText(text: string, visibleCount: number): string {
  if (text.length <= visibleCount * 2) return text;
  const start = text.slice(0, visibleCount + 2);
  const end = text.slice(-visibleCount);
  return `${start}...${end}`;
}

export function splitText(text: string, visibleCount: number): string {
  if (text.length <= visibleCount * 2) return text;
  const start = text.slice(0, visibleCount);
  const end = text.slice(-visibleCount);
  return `${start}...${end}`;
}

export async function generateHashFromFile(file: File): Promise<`0x${string}`> {
  const arrayBuffer = await file.arrayBuffer();

  const hashBuffer = await crypto.subtle.digest("SHA-256", arrayBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return `0x${hashHex}`;
}

export async function generateHashFromMultipleFile(
  files: File[]
): Promise<`0x${string}`[]> {
  return Promise.all(files.map((file) => generateHashFromFile(file)));
}

export const getIpAddress = async () => {
  try {
    const { data } = await axios.get<{ ip: string }>("https://ipinfo.io/json", {
      timeout: 5000,
    });

    return typeof data.ip === "string" ? data.ip : "";
  } catch (error) {
    return "";
  }
};

export const connectWalletRetx = async ({ password }: { password: string }) => {
  try {
    const wallet = ClientWallet.getInstance();
    // TODO: call api get private key
    const text = await userApi.getPrivateHash();
    const privateKey = await decryptString(text, password);
    wallet.key = privateKey as `0x${string}`;
    dispatch(networkActions.self.setCountLoadWallet(new Date().valueOf()));
  } catch (e) {
    throw e;
  }
};
